import React, { useState } from "react";
import styles from "./Tools.module.css";
import CryptoJS from "crypto-js";

const Sha256Hash = () => {
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState("");
  const [inputType, setInputType] = useState("text");

  const generateHash = async () => {
    try {
      let hashHex = null;
      if (inputType === "text") {
        hashHex = CryptoJS.SHA256(inputValue).toString(CryptoJS.enc.Hex);
      }
      else if (inputType === "hex"){
        let wordArray = CryptoJS.enc.Hex.parse(inputValue);
        hashHex = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
      }
      setResult(hashHex);
    } catch (error) {
      setResult(`Error: ${error.message}`);
    }
  };

  const generateDoubleHash = async () => {
    try {
      let hashHex = null;
      if (inputType === "text") {
        let wordArray = CryptoJS.SHA256(inputValue);
        hashHex = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
      }
      else if (inputType === "hex"){
        let wordArray = CryptoJS.enc.Hex.parse(inputValue);
        let hash1 = CryptoJS.SHA256(wordArray);
        hashHex = CryptoJS.SHA256(hash1).toString(CryptoJS.enc.Hex);
      }
      setResult(hashHex);
    } catch (error) {
      setResult(`Error: ${error.message}`);
    }
  };

  return (
    <div className={`${styles.tools} times mbox`}>
        <h4 className="text-center" title="Generate SHA256 hash or SHA256 double hash (SHA256d) for text or hex string">
        <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
        Generate SHA256 Hash
        </h4>
        <hr />
            <table width="100%">
                <tbody>
                <tr style={{ height: 90 }}>
                <td>
                    <div className={`${styles.enterHex}`}>Enter String Value: </div>
                    <div width="100%">
                    <input
                        type="text"
                        id="shainputValue"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                        placeholder="Enter text or hex string"
                        />
                    </div>
                    <div>
                        <label htmlFor="shahashType" style={{ marginRight: "4px"}}>Input String Format: </label>
                          <select
                            id="shahashType"
                            value={inputType}
                            onChange={(e) => setInputType(e.target.value)}
                            style={{ padding: "8px", marginTop: "5px" }}
                            >
                            <option value="text">Text String</option>
                            <option value="hex">Hex String</option>
                        </select>
                      </div>
                </td>
                </tr>
                <tr style={{ height: 60 }}>
                    <td>
                        <div>
                            <button className="btn btn-primary" title="Generate SHA256 hash for the input string" onClick={generateHash}>Generate Hash</button>
                            <button className="btn btn-primary" title="Generate SHA256 double hash for the input string" style={{ marginLeft: "7px "}} onClick={generateDoubleHash}>Generate Double Hash</button>
                        </div>
                    </td>
                </tr>
                <tr style={{ height: 90 }}>
                <td>
                    <div className="label">Hash Value: </div>
                    <div width="100%">
                    <input
                        id="shaResult"
                        readOnly={true}
                        type="text"
                        style={{ width: "100%", padding: "8px", marginTop: "5px", backgroundColor: "lightgray" }}
                        value={result}
                        />
                    </div>
                </td>
                </tr>
                </tbody>
            </table>
    </div>
  );
};

export default Sha256Hash;
